type RefreshCallback = () => void;

class RefreshManager {
  private static instance: RefreshManager;
  private lockedComponents: Set<string> = new Set();
  private queuedRefreshes: Set<RefreshCallback> = new Set();
  private activeSession: boolean = false;
  private pendingSyncs: Set<RefreshCallback> = new Set();

  private constructor() {}

  static getInstance(): RefreshManager {
    if (!RefreshManager.instance) {
      RefreshManager.instance = new RefreshManager();
    }
    return RefreshManager.instance;
  }

  startSession() {
    this.activeSession = true;
  }

  endSession() {
    this.activeSession = false;
    this.executeQueuedSyncsIfSafe();
  }

  lockComponent(componentId: string) {
    this.lockedComponents.add(componentId);
  }

  unlockComponent(componentId: string) {
    this.lockedComponents.delete(componentId);
    // Only try to execute syncs if we're not in an active session
    if (!this.activeSession) {
      this.executeQueuedSyncsIfSafe();
    }
  }

  queueRefresh(callback: RefreshCallback) {
    // Always queue refreshes
    this.pendingSyncs.add(callback);
    
    // Try to execute if conditions are right
    if (!this.activeSession && this.lockedComponents.size === 0) {
      this.executeQueuedSyncsIfSafe();
    }
  }

  private executeQueuedSyncsIfSafe() {
    // Only execute if no components are locked and we're not in an active session
    if (this.lockedComponents.size === 0 && !this.activeSession && this.pendingSyncs.size > 0) {
      
      
      // Take a snapshot of current syncs
      const syncsToExecute = Array.from(this.pendingSyncs);
      // Clear the queue before executing
      this.pendingSyncs.clear();
      
      // Execute each sync sequentially
      const executeSync = async (index: number) => {
        if (index >= syncsToExecute.length) return;
        
        try {
          await Promise.resolve(syncsToExecute[index]());
        } catch (error) {
          
        }
        
        // Execute next sync
        await executeSync(index + 1);
      };
      
      // Start executing syncs
      executeSync(0);
    }
  }

  // For debugging purposes
  getStatus() {
    return {
      lockedComponents: Array.from(this.lockedComponents),
      queuedRefreshes: this.queuedRefreshes.size,
      activeSession: this.activeSession,
      pendingSyncs: this.pendingSyncs.size
    };
  }
}

export const refreshManager = RefreshManager.getInstance();
